import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import {FileUploader, FileItem, ParsedResponseHeaders} from 'ng2-file-upload';

import {UploadUrl} from '../../lib/config';

import { ExtendFileItem } from '../../lib/interface';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit {
  @Output() InitCallback: EventEmitter<FileUploader> = new EventEmitter<FileUploader>();
  private uploader: FileUploader = new FileUploader({
    url: UploadUrl,
    isHTML5: true,
  });
  private hasBaseDropZoneOver = false;
  private hasAnotherDropZoneOver = false;
  constructor(
    private ChangeDetectorRef: ChangeDetectorRef
  ) {
  }
  ngOnInit() {
    this.uploader.onSuccessItem = (item, response, status, headers) => {
      if (status === 200) {
        this.uploadSuccess(item, response, status, headers);
      }
    };
    this.InitCallback.emit(this.uploader);
  }
  uploadSuccess(item: ExtendFileItem, response, status: number, headers: ParsedResponseHeaders) {
    console.log(item);
    response = JSON.parse(response);
    const data = response.body.result;
    item.sourcePath = data.path;
    item.showPath = data.origin + data.path;
    this.ChangeDetectorRef.detectChanges();
  }
  fileOverBase(e: any): void {
    console.log(e);
    this.hasBaseDropZoneOver = e;
  }

  fileOverAnother(e: any): void {
    console.log(e);
    this.hasAnotherDropZoneOver = e;
  }

}



// WEBPACK FOOTER //
// /Users/liyankai/Documents/github/seiya_web.git/src/app/shared/upload/upload.component.ts